module.exports = __webpack_public_path__ + "img/3.8407719e.webp";